import React from 'react'
import { Layout, Card } from 'antd';
import { Button, Col, Form, Row, useRouter } from '@digital/ui';
import LoginHeaderLogo from '../../../../../public/images/icone_mrn.png';
import LoginBoxLogo from '../../../../../public/images/logo_mrn_verde.svg';
import { DownloadOrdemCompraPropostaTecnica } from '@app/api/sas/sasDocumentoOrdemCompra';


const OrdemCompraPropostaTecnicaDownload = () => {
    const { match } = useRouter();
    const { key } = match.params;

    const handleDownload = () => {
        DownloadOrdemCompraPropostaTecnica(key)
    }

    return (
        <>
            {
                <style
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: `header.ant-app-header.ant-layout-header {background-color: #161616; display: block !important;} .ant-app-header-actions .ant-btn i.icon {color:#D0D0D0} .ant-app-header-actions .ant-btn i.icon:hover {color:#FFFFFF} .ant-app-header-actions .ant-btn:hover i.icon, .ant-app-header-actions .ant-btn:focus i.icon {padding: 0px; color: #FFFFFF; background-color: transparent; border-color: transparent;} .ant-app-header .ant-app-header-logo span {height: 48px; display: flex; align-items: center} .ant-app-header-logo > .anticon {display:none} .ant-app-header-title:before {content: url(${LoginHeaderLogo}); height: 28px; margin-left: 2px} header.ant-app-header.ant-layout-header{display:none !important}`,
                    }}
                />
            }
            <div className='login-view'>
                <Layout>
                    <Card style={{width: '100%'}}>
                        <Form >
                            <div className="login-box">
                                <Row>
                                    <Col>
                                        <div className="login-box-logo">
                                            <img src={LoginBoxLogo} />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="login-box-group">
                                            <h2 className="login-box-title-sig">SGC </h2>
                                            <div className="login-box-title">Sistema de Gestão de Contratos</div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="actions">
                                <Button title="Download" type="primary" onClick={handleDownload} />
                            </div>
                        </Form>
                    </Card>
                </Layout>
            </div>
        </>
    )
}

export default OrdemCompraPropostaTecnicaDownload